import axios from "axios";

export const pythonVmInstance = axios.create({
	baseURL: process.env.REACT_APP_PYTHON_APP_API_URL,
});

pythonVmInstance.interceptors.request.use((config) => {
	const token = localStorage.getItem("py_token"); // or from context/state
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
},
(error) => Promise.reject(error)
);

// Response middleware
pythonVmInstance.interceptors.response.use(
  (response) => {
    console.log("✅ Response:", response.status, response.config.url);
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.warn("🔒 Unauthorized! Redirecting to login...");
      localStorage.removeItem("token");
      window.location.href = "/";
	// window.location.reload(true);
    }
    return Promise.reject(error);
  }
);